<template>
  <ServicePage
    service-id="software"
    :monthly-cost="monthlyCost"
    :item-count="lines.length"
    :can-add="canAdd"
    @add="addLines"
  >
    <div class="space-y-6">
      <ConfigSection
        section-key="gitlab"
        title="GitLab"
        subtitle="Managed GitLab with version control and CI/CD"
        v-model:enabled="gitlab.enabled"
        :monthly-cost="cost(gitlabLine)"
      >
        <div class="space-y-5">
          <PriceTable
            :entries="gitlabEntries"
            selectable
            :selected="gitlab.plan"
            @select="gitlab.plan = $event"
          />
          <div class="grid grid-cols-1 md:grid-cols-2 gap-5">
            <NumberField v-model="gitlab.count" label="Number of installations" :min="1" />
          </div>
          <p v-if="gitlab.plan" class="text-xs text-slate-500">
            Availability target: {{ gitlab.plan.description }}
          </p>
        </div>
      </ConfigSection>

      <CostPreview v-if="lines.length" :lines-prop="lines" />
    </div>
  </ServicePage>
</template>

<script>
import { mapGetters } from "vuex";
import ServicePage from "@/components/config/ServicePage.vue";
import ConfigSection from "@/components/config/ConfigSection.vue";
import NumberField from "@/components/config/NumberField.vue";
import PriceTable from "@/components/config/PriceTable.vue";
import CostPreview from "@/components/config/CostPreview.vue";
import { configurable } from "@/mixins/configurable";
import { estimateLine, lineItem, priceOf } from "@/utils/pricing";

export default {
  name: "SoftwareService",
  components: { ServicePage, ConfigSection, NumberField, PriceTable, CostPreview },
  mixins: [configurable],
  data() {
    return {
      gitlab: { enabled: true, plan: null, count: 1 },
    };
  },
  computed: {
    ...mapGetters({ section: "pricing/section" }),

    gitlabEntries() {
      return this.section("software.gitlab") || [];
    },

    gitlabLine() {
      const { enabled, plan, count } = this.gitlab;
      if (!enabled || !plan) return null;

      return estimateLine({
        key: "software.gitlab",
        serviceId: "software",
        name: `GitLab ${plan.type}`,
        description: plan.description,
        config: { type: plan.type },
        items: [
          lineItem({
            label: `GitLab ${plan.type}`,
            detail: plan.description,
            quantity: 1,
            unit: "month",
            unitPrice: priceOf(plan),
          }),
        ],
        quantity: Math.max(1, Math.floor(Number(count) || 1)),
      });
    },

    lines() {
      return [this.gitlabLine].filter((line) => line && line.monthlyCost > 0);
    },
  },
  watch: {
    gitlabEntries: {
      immediate: true,
      handler(list) {
        if (!this.gitlab.plan && list.length) this.gitlab.plan = list[0];
      },
    },
  },
  methods: {
    cost(line) {
      return line ? line.monthlyCost : 0;
    },
  },
};
</script>
